import type {
  ProductStatusType,
  ProductTypeType,
} from "@/types/graphql/partner.generated";

// Спец-значение фильтра «без явного шаблона гео-доступа»: для бэкенда это null.
export const DEFAULT_COUNTRY_ACCESS_VALUE = "DEFAULT";

export interface ProductsListFilter {
  search?: string;
  countryAccessId?: string | null;
  dateFrom?: string;
  dateTo?: string;
  status?: ProductStatusType;
  types?: ProductTypeType[];
}

/**
 * Значения фильтра из querystring в плоские аргументы `products(...)`.
 * Единая сборка для списка и кнопки отчёта.
 */
export function buildProductsFilter(
  filter: Record<string, unknown>
): ProductsListFilter {
  return {
    search: filter.search as string | undefined,
    countryAccessId:
      filter.countryAccessId === DEFAULT_COUNTRY_ACCESS_VALUE
        ? null
        : (filter.countryAccessId as string | undefined) || undefined,
    dateFrom: filter.dateFrom as string | undefined,
    dateTo: filter.dateTo as string | undefined,
    status: (filter.status as ProductStatusType | undefined) || undefined,
    types: filter.types as ProductTypeType[] | undefined,
  };
}
